import { columnHelper } from './helper';

export const role = columnHelper.accessor((row) => row.role, {
  header: 'Role',
  cell: ({ getValue }) => getValue(),
});
